<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description" :multiple="multiple"></app-label>

        <!-- <input type="text" ref="handle" class="input" :value="value" :class="options" @input="update()" v-bind="$attrs" slot="input" /> -->

        <div class="dropdown-input" slot="input">
            <!-- Add dropdown -->
            <app-dropdown>
                <app-dropdown-trigger class="dropdown-input input w-full" slot-scope="{toggle}" :handle-click="toggle" :toggle="false">
                    <div style="display: inline-block; margin-right: 8px;" v-html="(multiple == true ? service_categories.map(o => o['icon']).join('') : content.icon)"></div>
                    <span v-if="multiple !== true" v-html="content.name"></span>
                </app-dropdown-trigger>

                <app-dropdown-menu slot="menu" width="200" direction="ltr" slot-scope="{toggle}">
                    <ul class="list-reset" style="padding: 3px;">
                        <li v-for="(item, i) in items" :key="i" class="dropdown-input-item" v-bind:class="(isSelectedCategory(item.value) == true ? 'active' : '')" style="display: inline-block;">
                            <span @click="change(item); (multiple !== true ? toggle() : 0)" style="display: block; padding: 3px; border: 1px solid #eee; border-radius: 3px; margin: 2px;" v-html="item.icon"></span>
                        </li>
                    </ul>
                </app-dropdown-menu>
            </app-dropdown>

            <input v-if="multiple !== true"
                type="hidden"
                ref="handle"
                :value="value"
                :class="options"
                @input="update()"
                v-bind="$attrs"
            />

            <input v-else
                type="hidden"
                ref="handle"
                :value="value"
                :class="options"
                @input="update()"
                v-bind="$attrs"
            />
        </div>
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import Dropdown from '@/components/Dropdown';
    import DropdownTrigger from '@/components/DropdownTrigger';
    import DropdownMenu from '@/components/DropdownMenu';

    export default {
        name: 'app-field-category',

        components: {
            'app-field': Field,
            'app-label': Label,
            'app-dropdown': Dropdown,
            'app-dropdown-menu': DropdownMenu,
            'app-dropdown-trigger': DropdownTrigger
        },

        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            multiple: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            items: {
                type: Array,
                required: false,
                default: []
            },
            service_categories: {
                type: Array,
                required: false,
                default: () => ([])
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            content: '',
            svg: ''
        }),

        mounted() {
            if (this.value) {
                this.items.forEach((item) => {
                    if (this.multiple == true) {
                        for (let index in this.value) {
                            if (item.value == this.value[index]) {
                                this.service_categories.push(item);
                            }
                        }
                    } else {
                        if (item.value == this.value) {
                            this.content = item;
                        }
                    }
                });
            }
        },

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },
        methods: {
            update() {
                this.$emit('input', (this.multiple !== true ? this.content.value : this.service_categories.map(o => o['value']).join(',')));
            },
            change(val) {
                if (this.multiple == true) {
                    // Check if category already selected
                    for (let index in this.service_categories) {
                        if (this.service_categories[index].value == val.value) {
                            this.service_categories.splice(index, 1);
                            this.update();
                            return true;
                        }
                    }

                    // If not already selected, push to array.
                    this.service_categories.push(val);
                    this.update();
                } else {
                    this.content = val;

                    this.update();
                }
            },
            isSelectedCategory(val) {
                for (let index in this.service_categories) {
                    if (this.service_categories[index].value == val) {
                        return true;
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';

    .dropdown-input {
        svg {
            margin-right: 5px;
            width: 25px; 
            height: 25px;
        }

        .dropdown-input-item {
            svg path, svg, rect {
                transition: fill 0.2s ease-in-out;
            }

            &:hover {
                svg {
                    path, rect {
                        fill: #0071BA;
                    }
                }
            }

            &.active {
                svg {
                    path, rect {
                        fill: #0071BA;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/fields/inputs/Category.vue